import { render, staticRenderFns } from "./AssetMortgage.vue?vue&type=template&id=2556d111"
import script from "./AssetMortgage.vue?vue&type=script&lang=js"
export * from "./AssetMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports